import React from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { logInReset, getProfileData, getAccountBalance } from 'redux/actions/login'
import { getUserNotices, readNotice } from 'redux/actions/notifications'
import { showSupportChat, hideSupportChat, setSupportChatIsReady } from 'redux/actions/settings'

export const redirectTo = to => dispatch => dispatch(push(to))

export const withLocation = Component =>
  connect(
    ({ router: { location } }) => ({ location }),
    {redirectTo}
  )(props => <Component {...props} />)

export const withProfile = Component =>
  connect(
    ({ user }) => ({ user }),
    { logInReset, getProfileData },
  )(props => <Component {...props} />)

export const withBalance = Component => connect(
  ({ balance: { amount, income, loading } }) => ({
    balanceAmount: amount,
    balanceIncome: income,
    balanceLoading: loading
  }),
  { getAccountBalance },
)(props => <Component {...props} />)

export const withNotifications = Component => connect(
  ({ notifications }) => ({ notifications }),
  { getUserNotices, readNotice },
)(props => <Component {...props} />)

export const withSupportChat = Component => connect(
  ({ settings: { supportChatIsVisible, supportChatIsReady } }) => ({ supportChatIsVisible, supportChatIsReady }),
  { showSupportChat, hideSupportChat, setSupportChatIsReady }
)(props => <Component {...props} />)
